/* eslint-disable react/jsx-props-no-spreading */
import { Provider } from 'react-redux';
import { ModalMasterData } from 'components/SearchSideBar/BasicInfo/types';
import { BreadCrumb } from '@doda/common/src/interfaces/breadCrumb';
import { MetaText } from '@doda/common/src/logics/metaTag';
import { KeywordsResultResponse } from '@doda/api-client/aspida/@types';
import { PrBannerResponse } from '@doda/common/src/interfaces/prBanner';
import { NearAreaDataType } from '@doda/common/src/interfaces/nearArea';
import { LinkBox } from '@doda/common/src/logics/seoFooterLinkData/createSeoFooterLink';
import { ButtonBox } from '@doda/common/src/logics/seoNarrowDownButtonData/createSeoNarrowDownButton';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from 'redux/store';
import { JobSearchListScreen } from './screens';
import { getServerSideProps } from './getServerSideProps';
import { SideBarProps } from './components/SearchSideBar/types';

/**
 * 検索結果一覧画面のprops
 */
export interface PageProps {
  sideBarProps: SideBarProps;
  modalMasterData: ModalMasterData;
  breadCrumb: BreadCrumb[];
  prBannerData: PrBannerResponse | null;
  isShowPagination: boolean;
  seoFooterLink: LinkBox[];
  leadSentence: string;
  explainText: string | null;
  metaTagData: MetaText;
  nearAreaData: NearAreaDataType | null;
  similarKeywordList: KeywordsResultResponse[];
  seoNarrowDownButtonData: ButtonBox[] | undefined;
}

const JobSearchList = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const { initialState, ...pageProps } = props;

  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <JobSearchListScreen {...pageProps} />
    </Provider>
  );
};

export { getServerSideProps };

export default JobSearchList;
